
<template>
    <div>
        <div class="layout justify-center wrap container text-xs-center" style="font-size: 20px;">
            {{$t('Please, login to see the requested content.')}}
        </div>
        <div class="layout justify-center wrap container text-xs-center">
            <v-btn color="primary" dark @click="showLogin">{{$t('Login')}}</v-btn>
        </div>
    </div>
</template>

<script>
    import { VFlex, VLayout, VContainer, VBtn } from 'vuetify/lib'

    export default {
        name: 'Login',
        components:{VFlex, VLayout, VContainer, VBtn},
        created(){
            if (this.$route.params.hasOwnProperty('next')) {
                console.log("next");
                console.log(JSON.stringify(this.$route.params.next));
            }
        },
        methods: {
            showLogin() {
                this.$emit('login');
            }
        }
    };
</script>

